(() => {
  const groupSelector = '.jdgm-form__rating';
  const starSelector = `${groupSelector} .jdgm-star[data-alt]`;
  let selectedRating = null;

  const getRating = (star) => {
    const value = Number.parseInt(star?.dataset.alt || '', 10);
    return value >= 1 && value <= 5 ? value : null;
  };

  const getStatus = (group) => {
    let status = group.nextElementSibling;

    if (!status?.classList.contains('glamp-jdgm-rating-status')) {
      status = document.createElement('span');
      status.className = 'glamp-jdgm-rating-status';
      status.setAttribute('aria-live', 'polite');
      status.textContent = '星を選択してください';
      group.insertAdjacentElement('afterend', status);
    }

    return status;
  };

  const applyRating = (group, value, announce = true) => {
    if (!group?.isConnected || value === null) return;

    const score = group.querySelector('input[name="score"]');
    const stars = [...group.querySelectorAll('.jdgm-star[data-alt]')];

    if (!score || stars.length !== 5) return;

    if (score.value !== String(value)) {
      score.value = String(value);
      score.dispatchEvent(new Event('input', { bubbles: true }));
      score.dispatchEvent(new Event('change', { bubbles: true }));
    }

    stars.forEach((star) => {
      const starValue = getRating(star);
      const isChecked = starValue === value;
      const isOn = starValue !== null && starValue <= value;

      star.classList.toggle('jdgm--on', isOn);
      star.classList.toggle('jdgm--off', !isOn);
      star.setAttribute('aria-checked', String(isChecked));
      star.tabIndex = isChecked ? 0 : -1;
    });

    group.dataset.glampSelectedRating = String(value);
    const status = getStatus(group);
    status.textContent = announce ? `${value}つ星を選択しました` : status.textContent;
  };

  const enhanceGroup = (group) => {
    if (!(group instanceof HTMLElement) || group.dataset.glampRatingEnhanced === 'true') return;

    group.dataset.glampRatingEnhanced = 'true';
    getStatus(group);

    const existingScore = Number.parseInt(group.querySelector('input[name="score"]')?.value || '', 10);
    const value = existingScore >= 1 && existingScore <= 5 ? existingScore : selectedRating;

    if (value !== null) applyRating(group, value, false);
  };

  const enhanceWithin = (root = document) => {
    if (root instanceof Element && root.matches(groupSelector)) enhanceGroup(root);
    root.querySelectorAll?.(groupSelector).forEach(enhanceGroup);
  };

  const selectFromEvent = (event) => {
    const target = event.target instanceof Element ? event.target.closest(starSelector) : null;
    if (!target) return;

    const value = getRating(target);
    const group = target.closest(groupSelector);
    if (value === null || !group) return;

    selectedRating = value;
    applyRating(group, value);

    window.setTimeout(() => {
      if (group.isConnected) applyRating(group, value);
      enhanceWithin(document);
    }, 0);
  };

  document.addEventListener('pointerup', selectFromEvent, true);
  document.addEventListener('touchend', selectFromEvent, { capture: true, passive: true });
  document.addEventListener('click', selectFromEvent, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    selectFromEvent(event);
  }, true);

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node instanceof Element) enhanceWithin(node);
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      enhanceWithin(document);
      observer.observe(document.body, { childList: true, subtree: true });
    }, { once: true });
  } else {
    enhanceWithin(document);
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
